import { render, staticRenderFns } from "./BrandVimeoPlayer.vue?vue&type=template&id=3a353411&scoped=true&"
import script from "./BrandVimeoPlayer.vue?vue&type=script&lang=js&"
export * from "./BrandVimeoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandVimeoPlayer.vue?vue&type=style&index=0&id=3a353411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a353411",
  null
  
)

export default component.exports